import React, { Fragment } from 'react'
import {AppTable,AppRow,AppButton} from 'qcc'
import {DemoApiTable} from './DemoApiTable'
import { Row, Icon } from 'antd';

const tableData =[
    {id:1,parentId:0,name:"一级菜单A",rank:1,code:'ppp'},
    {id:2,parentId:0,name:"一级菜单B",rank:1,code:'ppp'},
    {id:3,parentId:0,name:"一级菜单C",rank:1,code:'ppp'},
    {id:4,parentId:1,name:"二级菜单A-A",rank:2,code:'ppp'},
    {id:5,parentId:1,name:"二级菜单A-B",rank:2,code:'ppp'},
    {id:6,parentId:2,name:"二级菜单B-A",rank:2,code:'ppp'},
    {id:7,parentId:4,name:"三级菜单A-A-A",rank:3,code:'ppp'},
    {id:8,parentId:7,name:"四级菜单A-A-A-A",rank:4,code:'ppp'},
    {id:9,parentId:8,name:"五级菜单A-A-A-A-A",rank:5,code:'ppp'},
    {id:10,parentId:9,name:"六级菜单A-A-A-A-A-A",rank:6,code:'ppp'},
    {id:11,parentId:10,name:"七级菜单A-A-A-A-A-A-A",rank:7,code:'ppp'},
    {id:12,parentId:11,name:"八级菜单A-A-A-A-A-A-A-A",rank:8,code:'ppp'},
    {id:13,parentId:12,name:"九级菜单A-A-A-A-A-A-A-A-A",rank:9,code:'ppp'},
    {id:14,parentId:13,name:"十级菜单A-A-A-A-A-A-A-A-A-A",rank:10,code:'ppp'}
]

export const AppTableDemo = () =>{
    return (<div className='app-demo-content'>
            <h1>使用说明</h1>    
            <div>
                1、展示列表数据。<br/>
                2、可以展示树形结构，以及设置可编辑列表<br/>
                3、引用：import {`{AppTable}`} from 'qcc'<br/>
                4、demo位置：src/demo/components/AppTableDemo.tsx
            </div>

            <h1>DEMO</h1>
            <div className='app-demo-content-demo'>
                <Row  className="demo-title">
                    <label>通用表格</label>
                    <Row style={{fontSize:12}}>
                    1）如果外面容器的宽度足够，则其中的一列不设置宽度，为自适应；<br/>
                    2）外面容器宽度不够，则将列全部设置为固定，会出现横向滚动条。
                    </Row>
                </Row>
                
                <Row style={{marginLeft:20,marginRight:20,height:300,marginBottom:20}}>
                    <div style={{width:'100%',height:'100%'}}>
                        <AppTable dataSource={tableData} paging>
                            <AppTable.ColIndex />
                            <AppTable.ColCheckbox/>
                            <AppTable.Col title='名称' field='name'/>
                            <AppTable.ColInt title='整数hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh' width={100} field='rank' />
                            <AppTable.ColMoney title='金额' field='rank' width={100} />
                            <AppTable.ColAction render={(data:any,dataIndex:number)=>{
                                return (<AppRow itemSplit={10} style={{float:'right'}}>
                                    <AppButton type='link' label='编辑' />
                                    <AppButton type='link' label='删除' />
                                    <AppButton type='link' label='更多操作' >
                                        <AppButton.Item label='daochu'/>
                                        <AppButton.Item label='daochu'/>
                                        <AppButton.Item label='daochu'/>
                                        <AppButton.Item label='daochu'/>
                                    </AppButton>
                                </AppRow>)
                            }}/>
                        </AppTable>
                    </div>
                </Row>

                <Row  className="demo-title">
                    <label>树形结构</label>
                    <Row style={{fontSize:12}}>
                    1）设置一列为扩展列就展示为属性列表；<br/>
                    2）数据集要有parentId字段，用于树形结构的构建。
                    </Row>
                </Row>

                <Row style={{marginLeft:20,marginRight:20,height:300,marginBottom:20}}>
                    <div style={{width:'100%',height:'100%'}}>
                        <AppTable dataSource={tableData} >
                            <AppTable.ColIndex />
                            <AppTable.ColCheckbox/>
                            <AppTable.Col title='名称' field='name'  expand/>
                            <AppTable.ColInt title='整数hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh' width={100} field='rank' />
                            <AppTable.ColMoney title='金额' field='rank' width={100} />
                            <AppTable.ColAction render={(data:any,dataIndex:number)=>{
                                return (<AppRow itemSplit={10} style={{float:'right'}}>
                                    <AppButton type='link' label='编辑' />
                                    <AppButton type='link' label='删除' />
                                    <AppButton type='link' label='更多操作' >
                                        <AppButton.Item label='daochu'/>
                                        <AppButton.Item label='daochu'/>
                                        <AppButton.Item label='daochu'/>
                                        <AppButton.Item label='daochu'/>
                                    </AppButton>
                                </AppRow>)
                            }}/>
                        </AppTable>
                    </div>
                </Row>


                <Row  className="demo-title">
                    <label>左右固定</label>
                    <Row style={{fontSize:12}}>
                    1）设置固定列的位置，在出现横向滚动条后，可以固定列；<br/>
                    2）设置固定列的宽度一定要设置，否则为默认值100；<br/>
                    3）左边固定列属性为leftFixIndex，右边固定列属性为rightFixIndex。<br/>
                    4）不设置时，请不要设置改属性。
                    </Row>
                </Row>

                <Row style={{marginLeft:20,marginRight:20,height:300,marginBottom:20}}>
                    <div style={{width:'100%',height:'100%'}}>
                        <AppTable dataSource={tableData} leftFixIndex={2} rightFixIndex={5} >
                            <AppTable.ColIndex />
                            <AppTable.ColCheckbox/>
                            <AppTable.Col title='左边固定区域(leftFixIndex=2)' field='name' width={200}/>
                            <AppTable.ColInt title='非固定区域' width={400} field='rank' />
                            <AppTable.ColInt title='非固定区域' width={600} field='rank' />
                            <AppTable.ColMoney title='右边固定区域(rightFixIndex=5)' field='rank' width={200} />
                            <AppTable.ColAction width={300} render={(data:any,dataIndex:number)=>{
                                return (<AppRow itemSplit={10} style={{float:'right'}}>
                                    <AppButton type='link' label='编辑' />
                                    <AppButton type='link' label='删除' />
                                    <AppButton type='link' label='更多操作' >
                                        <AppButton.Item label='daochu'/>
                                        <AppButton.Item label='daochu'/>
                                        <AppButton.Item label='daochu'/>
                                        <AppButton.Item label='daochu'/>
                                    </AppButton>
                                </AppRow>)
                            }}/>
                        </AppTable>
                    </div>
                </Row>


            </div>
            
            <h1>API</h1>
            <h2>AppTable api</h2>
            
            <h2>AppTable.Col api</h2>
            
    </div>)
}


// WEBPACK FOOTER //
// ./src/demo/components/AppTableDemo.tsx